
export default {

  setSectionGoods (state, payload) {
    if (!payload) {
      throw new Error('Not a goods data')
    }
    let { type, data } = payload
    if (type && data) {
      for (let key in data) {
        state.sectionGoods[type][key] = data[key]
      }
    }
  },

  clearSection (state, payload) {
    state.sectionGoods = {
      brand: {
        contain: '',
        exclude: ''
      },
      cate: {
        contain: '',
        exclude: ''
      },
      goods: {
        contain: '',
        exclude: ''
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/store/section-product/mutations.js